
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import UserModule from '@/store/modules/UserModule';
import Footer from '@/components/Menu/Footer.vue';
import MenuDrawerItem from '@/components/Menu/MenuDrawerItem.vue';
import MenuItem from '@/model/menuItem';

@Component({
  components: {
    Footer,
    MenuDrawerItem,
  },
})
export default class MenuDrawer extends Vue {
  public isOpen: boolean = false;

  public get menuItems(): MenuItem[] {
    const defaultAccess: MenuItem[] = [
      {
        link: '/',
        icon: 'home-outline',
        title: this.$t('Sidebar.Home'),
        children: undefined,
      },
      {
        link: undefined,
        icon: 'apache-kafka',
        title: this.$t('Sidebar.FlowsLive'),
        children: [
          {
            link: '/app/flows-live/dev',
            icon: 'xml',
            title: this.$t('Flows.Environment.Development'),
            children: undefined,
          },
          {
            link: '/app/flows-live/staging',
            icon: 'list-box-outline',
            title: this.$t('Flows.Environment.Staging'),
            children: undefined,
          },
          {
            link: '/app/flows-live/prod',
            icon: 'sitemap-outline',
            title: this.$t('Flows.Environment.Production'),
            children: undefined,
          },
        ],
      },
      {
        link: '/app/flows-list',
        icon: 'list-box-outline',
        title: this.$t('Sidebar.FlowsList'),
        children: undefined,
      },
    ];

    const children: MenuItem[] = [];

    if (UserModule.isEAITeamOrAdmin) {
      children.push({
        link: '/app/admin/users',
        icon: 'account-outline',
        title: this.$t('Sidebar.User'),
        children: undefined,
      });
      children.push({
        link: '/app/admin/roles',
        icon: 'badge-account-outline',
        title: this.$t('Sidebar.Role'),
        children: undefined,
      });
      children.push({
        link: '/app/admin/management',
        icon: 'badge-account-outline',
        title: this.$t('Sidebar.Management'),
        children: undefined,
      });
    }

    if (children.length > 0) {
      defaultAccess.push({
        link: undefined,
        icon: 'cog-outline',
        title: this.$t('Sidebar.Administration'),
        children,
      });
    }

    return defaultAccess;
  }

  public get isPinned() {
    return UserModule.menuIsPinned;
  }

  public inversePinValue() {
    UserModule.updatePinMenu(!this.isPinned);
  }
}
